export default __webpack_public_path__ + "static/media/homevilla2.0f3869dc.jpg";